
//drawer
export const getDrawer = () => {
    let drawer = localStorage.getItem('drawer');
    return drawer === 'false' ? false : true;
};

export const setDrawer = (value) => localStorage.setItem('drawer', value);

//theme
export const getTheme = () => {
    let localTheme = localStorage.getItem("themeType");
    return localTheme ? localTheme : "light";
};

export const setTheme = theme => {
    let newThemeType = (theme === "light") ? "dark" : "light";
    localStorage.setItem("themeType", newThemeType);
    return newThemeType;
};

//cookies acceptance
export const getCookiesAcceptance = () => {
    let cookies = localStorage.getItem('cookiesAccepted');
    return cookies === 'false' || !cookies ? false : true;
};

export const setCookieAccepted = () => {
    localStorage.setItem('cookiesAccepted', true);
};